<template>
  <v-container>
    <v-layout align-center>
      <v-flex xs10>
        <h3 class="primary--text">Vendas no site</h3>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex xs12 md4 text-xs-right>
        <v-text-field
          label="Pesquisar"
          v-model="filtro"
          color="secondary"
          append-icon="search"
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-layout justify-space-around row wrap>
      <v-flex xs12>
        <v-card class="default-border" flat>
          Valor Total:
          <b>{{
            valorTotal.toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            })
          }}</b>
          <v-data-table
            :headers="headers"
            :items="listaVendas"
            class="elevation-1"
            :search="filtro"
            :pagination.sync="pagination"
          >
            <template v-slot:items="props">
              <td>{{ props.item.id }}</td>
              <td>{{ props.item.first_name }}</td>
              <td>
                {{ props.item.cellphone ? props.item.cellphone : "vazio" }}
              </td>
              <td>
                {{ props.item.status }}
              </td>
              <td>
                {{ props.item.produts }}
              </td>
              <td>{{ props.item.payment_method_title }}</td>
              <td>
                {{
                  props.item.total.toLocaleString("pt-br", {
                    style: "currency",
                    currency: "BRL",
                  })
                }}
              </td>
              <td>
                {{
                  customFormatComputed.toLocaleDateTimeString(
                    props.item.date_created
                  )
                }}
              </td>
              <!--<td class="text-xs-center">
                <v-icon
                  @click="
                    goEdit(cipherComputed.encrypt(props.item.idContasReceber))
                  "
                  >edit</v-icon
                >
                <v-icon @click="deletePag(props.item.idContasReceber)"
                  >delete</v-icon
                >
              </td> -->
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar
      :timeout="3200"
      :color="`${snackbarModel.sucesso ? 'success' : 'error'}`"
      v-model="snackbarModel.mostrar"
      bottom
      multi-line
    >
      {{ snackbarModel.text }}
      <v-btn dark flat @click.native="snackbarModel.mostrar = false"
        >Fechar</v-btn
      >
    </v-snackbar>
  </v-container>
</template>

<script>
import cipher from "@/helpers/cipher.js";
import customFormat from "@/helpers/custom-format.js";
import permissoes from "@/helpers/permissoes.js";
import jwt from "@/helpers/jwt";
import WooCommerceRestApi from "@woocommerce/woocommerce-rest-api";

export default {
  name: "VendasSite",
  data: () => ({
    valorTotal: 0.0,
    snackbarModel: {
      mostrar: false,
      sucesso: false,
      text: "",
    },
    filtro: "",
    pagination: { sortBy: "date_created", descending: true, rowsPerPage: 20 },
    headers: [
      { text: "Cod. Compra", value: "id" },
      { text: "Cliente", value: "first_name" },
      { text: "Telefone", value: "cellphone" },
      { text: "Status", value: "status" },
      { text: "Produto", value: "produts" },
      { text: "Forma Pag,", value: "payment_method_title" },
      { text: "Valor Total", value: "total" },
      { text: "Data Incluso", value: "date_created" },
    ],
    modelo: {
      id: null,
      first_name: null,
      cellphone: null,
      status: null,
      produts: null,
      payment_method_title: null,
      total: null,
      date_created: null,
    },
    listaVendas: [],
  }),
  mounted: function () {
    this.buscarCompras();
    this.externalSnackbarMessage();
  },
  computed: {
    customFormatComputed: function () {
      return customFormat;
    },
    cipherComputed: function () {
      return cipher;
    },
  },
  methods: {
    somatorio: function (list) {
      const self = this;
      var valorTotal = 0.0;
      list.forEach((e) => {
        valorTotal = parseFloat(e.total) + valorTotal;
      });

      return valorTotal;
    },
    buscarCompras: function () {
      const self = this;

      const api = new WooCommerceRestApi({
        url: "https://maistoppormenos.com.br",
        consumerKey: "ck_42c55cf6f851bc710d7eb16a598c7b2abb583b0f",
        consumerSecret: "cs_d7b3587e0d3144debdd24ab1a6cfddfbae512c15",
        version: "wc/v3",
        axiosConfig: { headers: {} },
      });

      api
        .get("orders", {
          status: ["pending", "processing", "on-hold"],
          //any, pending, processing, on-hold, completed, cancelled, refunded, failed and trash
        })
        .then((response) => {
          if (response.status == 200) {
            const data = response.data;

            for (let indexC = 0; indexC < data.length; indexC++) {
              const c = data[indexC];

              var listaProd = [];
              for (let indexP = 0; indexP < c.line_items.length; indexP++) {
                const p = c.line_items[indexP];

                if (p.sku == String(jwt.decryptToken().idconta)) {
                  listaProd.push({ name: p.name, total: parseFloat(p.total) });
                }
              }

              if (listaProd.length > 0) {
                let status;
                switch (c.status) {
                  case "pending":
                    status = "Pendente";
                    break;
                  case "processing":
                    status = "Processando";
                    break;
                  case "on-hold":
                    status = "Aguardando";
                    break;
                }

                let add = Object.create(this.modelo, {
                  id: { value: c.id },
                  first_name: { value: c.billing.first_name },
                  cellphone: { value: c.billing.cellphone },
                  status: { value: status },
                  produts: {
                    value: listaProd
                      .map(function (elem) {
                        return elem.name;
                      })
                      .join(", "),
                  },
                  payment_method_title: {
                    value: c.payment_method_title,
                  },
                  total: { value: self.somatorio(listaProd) },
                  date_created: { value: c.date_created },
                });
                self.listaVendas.push(add);
              }
            }

            self.valorTotal = self.somatorio(self.listaVendas);
          }

          console.log("Response Data:", response.data);
        })
        .catch((error) => {
          // Invalid request, for 4xx and 5xx statuses
          console.log(error);
          //console.log("Response Status:", error.response.status);
          //console.log("Response Headers:", error.response.headers);
          //console.log("Response Data:", error.response.data);
        })
        .finally(() => {
          // Always executed.
        });
    },
    deletePag: function (id) {
      const self = this;
      if (confirm("O Pagamento vai ser apagado !")) {
        self.$http
          .get(`${process.env.URL_API}/contasreceber/v1/delete/` + id, {
            headers: {
              Authorization:
                "Bearer " + JSON.parse(localStorage.getItem("token")),
            },
          })
          .then(function (response) {
            const data = response.data;
            self.buscarPagamentos();
            self.snackbarModel.text = data.mensagem;
            self.snackbarModel.sucesso = true;
            self.snackbarModel.mostrar = true;
            self.disableBtnFinalizar = false;
          });
      }
    },
    goEdit: function (id) {
      const self = this;
      self.$router.push({ name: "EditarCaixa", params: { id: id } });
    },
    externalSnackbarMessage: function () {
      const self = this;
      if (self.$route.params.snackbarMostrar) {
        self.snackbarModel.sucesso = self.$route.params.snackbarSucesso;
        self.snackbarModel.text = self.$route.params.snackbarText;
        self.snackbarModel.mostrar = self.$route.params.snackbarMostrar;
      }
    },
    go: function (routeName, routeParams) {
      const self = this;
      if (!routeParams) {
        self.$router.push({ name: routeName });
      } else {
        self.$router.push({ name: routeName, params: routeParams });
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/caixa/VendasSite.vue